import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const MainLayout = ({ main, side, isAutoOverflow }) => (
  <div
    className={clsx(
      `container mx-auto flex-1 justify-center`,
      isAutoOverflow && 'overflow-auto',
    )}
  >
    <div className={clsx(`${side ? 'md:flex' : 'lg:flex'}`)}>
      <div className="flex flex-col flex-1 rtl:pl-32">{main}</div>
      {side ? (
        <div className="flex flex-col md:w-320 hidden md:block">{side}</div>
      ) : (
        ''
      )}
    </div>
  </div>
)

MainLayout.propsType = {
  main: PropTypes.func,
  side: PropTypes.func,
}

export default MainLayout
